module.exports = __webpack_public_path__ + "static/media/objects_01.cf4a2824.svg";